import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { ButtonComponent } from '../../atoms/button/button.component';

@Component({
  selector: 'app-side-drawer',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent],
  templateUrl: './side-drawer.component.html',
  styleUrls: ['./side-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideDrawerComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() width = 'w-[500px]'; // Default width
  @Input() showFooter = true;
  @Input() saveButtonLabel = 'Save'; // Default save button text
  @Input() saveDisabled = false; // Disable primary CTA until caller enables it
  @Input() showBackdrop = true; // Default: show backdrop
  @Input() closeOnBackdropClick = false; // Default: don't close on backdrop click

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onSave(): void {
    if (this.saveDisabled) return;
    this.save.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (this.closeOnBackdropClick && event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
